import React, { useEffect, useState } from "react";
// import SectionHeading from "../SectionHeading/SectionHeading";

const api = "AIzaSyBiNSppdp9mrw_NCMLr2aG2M-k0a5hmE_o";
const channelId = "UCzjtEsnXEIY0XTH_krchs0A";
const fetchUrl = `https://www.googleapis.com/youtube/v3/search?key=${api}&channelId=${channelId}&part=snippet,id&order=date&maxResults=20`;

const videoData = [
  {
    VideoLink: "https://www.youtube.com/embed/eQ3VBrAd4hI",
    title:
      "Understanding Male Infertility | male infertility causes | testosterone | Dr. Archana Shrivastav",
    publishedAt: "2025-05-09T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/UFRmMDniLbk",
    title:
      "Primary factor of infertility | Male | Female | Dr. Archana Shrivastav | Jabalpur Fertility Centre",
    publishedAt: "2025-05-08T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/GKc1PJA04yw",
    title:
      "Infertile couple | Causes of infertility | Fertility solutions | OPD | Dr. Archana Shrivastav",
    publishedAt: "2025-05-07T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/yazy36SHbVE",
    title:
      "Patient Story | IVF Story | Gynaecologist | IVF Specialist | Dr. Archana Shrivastav | Awareness",
    publishedAt: "2025-04-23T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/46nyueKjX1M",
    title:
      "7 साल का इंतज़ार हुआ खत्म | माता-पिता बनने का सुख | डॉ. अर्चना श्रीवास्तव | जबलपुर फर्टिलिटी सेंटर",
    publishedAt: "2025-04-08T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/hlRdznUBXq4",
    title:
      "9 साल का इंतज़ार, खुशियों की सौगात | डॉ. अर्चना श्रीवास्तव | जबलपुर फर्टिलिटी सेंटर | जबलपुर",
    publishedAt: "2025-04-05T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/5vqtECIz6T4",
    title: "24 साल की उम्मीद, एक खूबसूरत चमत्कार! ✨👶",
    publishedAt: "2025-04-04T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/SStIVA44KHM",
    title:
      "She never expected her journey to lead to IVF | Dr. Archana Shrivastav | Jabalpur Fertility Centre",
    publishedAt: "2025-03-18T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/LbMWZLYg32w",
    title:
      "Parenthood Should Be a Choice, Not a Chance | Dr. Archana Shrivastav | Jabalpur Fertility Centre",
    publishedAt: "2025-03-11T00:00:00Z",
  },
];

const AttendLiveEvents = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const resJson = await response.json();
        console.log("API Response:", resJson);
        const result = resJson.items.map((doc) => ({
          ...doc,
          VideoLink: "https://www.youtube.com/embed/" + doc.id.videoId,
          publishedAt: doc.snippet.publishedAt,
          title: doc.snippet.title,
        }));
        setVideos(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const truncateTitle = (title, maxLength) => {
    if (title.length <= maxLength) {
      return title;
    }
    return title.substring(0, maxLength) + "...";
  };

  const videosToShow = videos.slice(0, 9);

  return (
    <div className="container">
      <div className="row">
        {videosToShow.length
          ? videosToShow.map((video, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                <div className="st-post st-style3">
                  <div className="st-post-thumb st-link-hover-wrap st-zoom">
                    <iframe
                      className="embed-responsive-item"
                      width="100%"
                      height="300px"
                      allowFullScreen
                      src={video.VideoLink}
                      title={`YouTube video player ${index + 1}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    ></iframe>
                  </div>
                  <div
                    className="st-post-title"
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {truncateTitle(video.title, 30)}
                  </div>
                  <div
                    className="st-post-date"
                    style={{
                      color: "#666666",
                      fontWeight: "bold",
                      fontSize: "14px",
                      marginTop: "10px",
                    }}
                  >
                    {formatDate(video.publishedAt)}
                  </div>
                  <div
                    className="mb-5"
                    style={{
                      color: "#666666",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    Posted by : Dr.Archana Shrivastav
                  </div>
                </div>
              </div>
            ))
          : videoData.map((video, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                <div className="st-post st-style3">
                  <div className="st-post-thumb st-link-hover-wrap st-zoom">
                    <iframe
                      className="embed-responsive-item"
                      width="100%"
                      height="300px"
                      allowFullScreen
                      src={video.VideoLink}
                      title={`YouTube video player ${index + 1}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    ></iframe>
                  </div>
                  <div
                    className="st-post-title"
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {truncateTitle(video.title, 30)}
                  </div>
                  <div
                    className="st-post-date"
                    style={{
                      color: "#666666",
                      fontWeight: "bold",
                      fontSize: "14px",
                      marginTop: "10px",
                    }}
                  >
                    {formatDate(video.publishedAt)}
                  </div>
                  <div
                    className="mb-5"
                    style={{
                      color: "#666666",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    Posted by : Dr.Archana Shrivastav
                  </div>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

const PostBlog = ({ data }) => {
  return (
    <section id="blog">
      <div className="st-height-b120 st-height-lg-b80" />
      {/* <SectionHeading
        title="Latest News"
        subTitle="Stay updated with our latest news: breakthroughs, events, and insights. <br /> Explore the forefront of innovation and stay informed."
      /> */}
      <div className="container">
        <div className="row">
          <AttendLiveEvents />
          <div className="st-height-b120 st-height-lg-b80" />
        </div>
      </div>
    </section>
  );
};

export default PostBlog;
